import { Plural, Trans } from '@lingui/react/macro';

import { ActivityOfType } from '@/components/activities/Activity';
import { ActivityMediumLink } from '@/components/activities/ActivityMediumLink';
import {
  BaseActivity,
  BaseActivityArticlesNames,
  BaseActivityText,
} from '@/components/activities/BaseActivity/BaseActivity';
import IconValidation from '@/icons/Validation.svg';
import { useRequestContext } from '@/routes/Requests/contexts/RequestContext';

export const JobAutoAcceptedActivity = ({
  activities,
}: {
  activities: ActivityOfType<'job_auto_accepted'>[];
}) => {
  const { iam } = useRequestContext();
  const firstActivity = activities[0];

  const workshopName = firstActivity.workshop.name;

  const userWorkshopIds = iam.scopesOnRequest
    .filter(({ scope }) => scope === 'workshop')
    .map(({ entityId }) => entityId);
  const hideQuote =
    iam.hasOnlyWorkshopScopeOnRequest && !userWorkshopIds.includes(firstActivity.workshopId);

  return (
    <BaseActivity
      createdAt={firstActivity.createdAt}
      type="primary"
      icon={<IconValidation />}
      message={
        <BaseActivityText>
          <Trans id="activities.job_auto_accepted.message">
            <strong>{workshopName}</strong> auto-accepted the job{' '}
            <Plural value={activities.length} other="with items:" one="" />
            {activities.length > 1 && (
              <BaseActivityArticlesNames activities={activities} displayArticleName />
            )}
          </Trans>
        </BaseActivityText>
      }
    >
      {/*
        Activities are ordered by createdAt desc, so [0] is the most recent.
        Each accept regenerates a workshop quote that already includes previously
        accepted articles for this workshop, so only the latest medium is useful.
      */}
      {firstActivity.medium && !hideQuote && <ActivityMediumLink medium={firstActivity.medium} />}
    </BaseActivity>
  );
};
